import { createSelector } from 'reselect'

const quiz_cancel_selector = createSelector(
	[ state => state.quiz ],
	quizState => ({
		isModified: quizState.isModified,
	})
)

export default quiz_cancel_selector
